import { Component, ChangeDetectionStrategy, Input, OnInit, OnDestroy } from "@angular/core";
import { take } from "rxjs/operators";
import { DynamicDialogConfig } from "primeng/dynamicdialog";

import { SseService } from "@app/user/user-core/server-sent-events.service";

export type ProcessStatus =
	"AGGREGATION" |
	"CANCEL" |
	"CHECK_VERSION" |
	"CREATE_INVITATION" |
	"CREATE_REGISTRY" |
	"CREATE_REQUESTS" |
	"DELETE" |
	"DISAGGREGATION" |
	"EDIT_INVITATION" |
	"ERROR" |
	"GET_MARKS_PARAMS" |
	"IMPORT" |
	"LOADING_FILE" |
	"OK" |
	"PENDING" |
	"REQUEST_PROCESSING" |
	"SAVE" |
	"SAVE_FILE" |
	"SC_CRYPTO_ANSWER" |
	"SEND" |
	"SIGN" |
	"TREE_CONSTRUCTION" |
	"WRITE_OF";

@Component({
	selector: "app-pending",
	templateUrl: "./pending.component.html",
	styleUrls: ["./pending.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PendingComponent implements OnInit, OnDestroy {
	@Input() public description?: ProcessStatus;
	@Input() public isBlackTheme = false;
	public timePending: any;

	constructor(
        public config: DynamicDialogConfig,
		private sseService: SseService,
	) { }

	public ngOnInit(): void {
		if (this.config?.data?.description) {
			this.description = this.config?.data?.description;
		}
		if (this.config?.data?.isBlackTheme) {
			this.isBlackTheme = this.config?.data?.isBlackTheme;
		}
		this.timePending = setTimeout(() => {
			this.sseService.eventSource?.close();
		}, 10000);
	}

	public ngOnDestroy(): void {
		if (this.timePending) clearTimeout(this.timePending);
		if (this.sseService.eventSource?.readyState === 2) {
			this.sseService.getServerSentEvent()
				.pipe(take(1))
				.subscribe();
		}
	}
}
